import React from "react";
import PropTypes from "prop-types";
import { PRICINGOVERVIEW } from "npmlinks-constants";
import { ToCurrency } from "../../../utils";

const StickyPricingOverview = props => {
  const { overview: { total } } = props;
  if (!total) {
    return null;
  }
  return (
    <div className="nw-stickypricingoverview-container nw-mobile-only">
      <span className="nw-stickypricingoverview-text">
        {PRICINGOVERVIEW.TOTAL.total}
      </span>
      <span className="nw-stickypricingoverview-text">{ToCurrency(total)}</span>
    </div>
  );
};
StickyPricingOverview.propTypes = {
  overview: PropTypes.shape({}).isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: StickyPricingOverview,
  component: StickyPricingOverview,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/CheckoutComponents/StickyPricingOverview/index.js